import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UISection from 'UIComponents/section/UISection';
import DiagnosisPanelContainer from 'flow-doctor-lib/components/diagnosis/DiagnosisPanelContainer';
import EnrollmentDiagnosisPanelBody from 'flow-doctor-lib/components/diagnosis/EnrollmentDiagnosisPanelBody';
import withEnrollmentEvent from 'flow-doctor-lib/hooks/withEnrollmentEvent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentDiagnosisPanel = ({
  enrollmentError,
  enrollmentEvent,
  failureMarker,
  loadingEnrollment,
  successMarker,
  onClose
}) => {
  return /*#__PURE__*/_jsx(DiagnosisPanelContainer, {
    onClose: onClose,
    objectTypeId: enrollmentEvent === null || enrollmentEvent === void 0 ? void 0 : enrollmentEvent.objectTypeId,
    children: /*#__PURE__*/_jsx(UISection, {
      children: enrollmentError ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [failureMarker, /*#__PURE__*/_jsx(UIErrorMessage, {
          type: "badRequest",
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.errorState.title"
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.errorState.descriptionFetchEnrollment"
          })
        })]
      }) : loadingEnrollment || !enrollmentEvent ? /*#__PURE__*/_jsx(UILoadingSpinner, {}) : /*#__PURE__*/_jsx(EnrollmentDiagnosisPanelBody, {
        enrollmentEvent: enrollmentEvent,
        failureMarker: failureMarker,
        successMarker: successMarker
      })
    })
  });
};
export default withEnrollmentEvent(EnrollmentDiagnosisPanel);